import React from 'react';
import PropTypes from 'prop-types';
import {VISIBILITY} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';

/**
 * HiddenComponent:
 *  - Hides current component untile visibilty props is set.
 */
export function HiddenComponent({visibility, children}) {
  if (VISIBILITY.HIDDEN === visibility)
    return (
      <div className='hide-component'>
        <h3 className='hide-component__message'>Solve Previous Question</h3>
      </div>
    );
  else return children;
}

HiddenComponent.propTypes = {
  /**
   * Current state of visibility [visible/hidden]
   */
  visibility: PropTypes.oneOf([VISIBILITY.HIDDEN, VISIBILITY.VISIBLE]),
  /**
   * Component to be displayed when state 'visible'
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

HiddenComponent.defaultProps = {
  visibility: VISIBILITY.VISIBLE,
};
